import { Component, OnInit, Input } from '@angular/core';
import { Principal } from 'src/app/models/principal';

declare var $: any;

@Component({
  selector: 'app-product-rekanan-filter',
  templateUrl: './product-rekanan-filter.component.html',
  styleUrls: ['./product-rekanan-filter.component.css']
})
export class ProductRekananFilterComponent implements OnInit {

  @Input() public principal: Principal[] = [];
  @Input() public principalSourceData: Principal[];
  public message = '';
  public isSuccess = false;
  public modalId = 'modal-filter-principal';

  constructor() { }

  ngOnInit() {

  }

  public show(): void {
    $('#' + this.modalId).modal('show');
  }

  public hide(): void {
    $('#' + this.modalId).modal('hide');
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}
